import { useState, useEffect } from "react";
import { api, timeAgo } from "../../context";

export default function Reports({ t }) {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [flash, setFlash] = useState("");

  const CARD=t.card,BORDER=t.border,TEXT=t.text,SUB=t.sub,PRI=t.pri,GRN=t.grn,RED=t.red,GOLD=t.gold;
  const showFlash = (msg) => { setFlash(msg); setTimeout(() => setFlash(""), 3000); };

  const load = async () => {
    setLoading(true);
    const r = await api("/admin/reports");
    if (r.ok) setReports(r.data?.data || []);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const resolve = async (id, status) => {
    const r = await api(`/admin/reports/${id}/resolve`, { method: "POST", body: JSON.stringify({ status, note: status }) });
    if (r.ok) { showFlash(status === "resolved" ? "Resolved ✓" : "Dismissed"); load(); }
  };

  const pending = reports.filter(r => r.status === "pending");
  const resolved = reports.filter(r => r.status !== "pending");

  return (
    <div>
      {flash && <div style={{ position: "fixed", top: 20, right: 20, background: GRN, color: "#fff", padding: "10px 20px", borderRadius: 10, fontWeight: 700, fontSize: 13, zIndex: 9999 }}>{flash}</div>}

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800, color: TEXT }}>⚠️ Reports</div>
          <div style={{ fontSize: 12, color: SUB, marginTop: 4 }}>{pending.length} pending · {resolved.length} resolved</div>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <div style={{ padding: "8px 16px", borderRadius: 10, background: `${RED}20`, border: `1px solid ${RED}30`, color: RED, fontSize: 13, fontWeight: 700 }}>
            {pending.length} Pending
          </div>
          <div style={{ padding: "8px 16px", borderRadius: 10, background: `${GRN}20`, border: `1px solid ${GRN}30`, color: GRN, fontSize: 13, fontWeight: 700 }}>
            {resolved.length} Resolved
          </div>
        </div>
      </div>

      {loading && <div style={{ textAlign: "center", padding: 40, color: SUB }}>Loading...</div>}

      {!loading && !reports.length && (
        <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "60px 24px", textAlign: "center" }}>
          <div style={{ fontSize: 40, marginBottom: 16 }}>✅</div>
          <div style={{ fontSize: 16, fontWeight: 700, color: TEXT, marginBottom: 8 }}>All clear!</div>
          <div style={{ fontSize: 13, color: SUB }}>No reports to review</div>
        </div>
      )}

      {!loading && reports.length > 0 && (
        <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, overflow: "hidden" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr style={{ background: t.hover, borderBottom: `2px solid ${BORDER}` }}>
                {["Reporter", "Reason", "Content", "Time", "Status", "Actions"].map(h => (
                  <th key={h} style={{ padding: "12px 16px", textAlign: "left", fontSize: 10, fontWeight: 700, color: SUB, textTransform: "uppercase" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {reports.map((r, i, arr) => (
                <tr key={r.id} style={{ borderBottom: i < arr.length - 1 ? `1px solid ${BORDER}` : "none", background: r.status === "pending" ? `${RED}05` : "transparent" }}>
                  <td style={{ padding: "12px 16px", fontWeight: 700, color: TEXT }}>{r.reporter?.name || "User"}</td>
                  <td style={{ padding: "12px 16px", color: SUB }}>{r.reason}</td>
                  <td style={{ padding: "12px 16px", color: SUB, fontSize: 12, maxWidth: 200 }}>
                    {r.reportable?.content ? r.reportable.content.slice(0, 80) + "..." : "Content removed"}
                  </td>
                  <td style={{ padding: "12px 16px", color: SUB, fontSize: 12, whiteSpace: "nowrap" }}>{timeAgo(r.created_at)}</td>
                  <td style={{ padding: "12px 16px" }}>
                    <span style={{ padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700, background: r.status === "pending" ? `${GOLD}20` : `${GRN}20`, color: r.status === "pending" ? GOLD : GRN }}>
                      {r.status}
                    </span>
                  </td>
                  <td style={{ padding: "12px 16px" }}>
                    {r.status === "pending" && (
                      <div style={{ display: "flex", gap: 6 }}>
                        <button onClick={() => resolve(r.id, "resolved")} style={{ padding: "5px 12px", borderRadius: 8, border: "none", background: `${GRN}20`, color: GRN, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>Resolve</button>
                        <button onClick={() => resolve(r.id, "dismissed")} style={{ padding: "5px 12px", borderRadius: 8, border: `1px solid ${BORDER}`, background: "transparent", color: SUB, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>Dismiss</button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}